(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-task-type-attribute', {
            parent: 'entity',
            url: '/custom-task-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attributes.html',
                    controller: 'CustomTaskTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-task-type-attribute-detail', {
            parent: 'custom-task-type-attribute',
            url: '/custom-task-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-detail.html',
                    controller: 'CustomTaskTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
                    return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-task-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-task-type-attribute-detail.edit', {
            parent: 'custom-task-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-task-type-attribute.new', {
            parent: 'custom-task-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('custom-task-type-attribute');
                });
            }]
        })*/
        
        .state('custom-task-type-attribute.new', {
			parent : 'custom-task-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-task-type-attribute.edit', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-task-type-attribute.edit', {
			parent : 'custom-task-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customTaskTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTaskTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
					return CustomTaskTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-task-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-task-type-attribute.delete', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-delete-dialog.html',
                    controller: 'CustomTaskTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-task-type-attribute', {
            parent: 'entity',
            url: '/custom-task-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attributes.html',
                    controller: 'CustomTaskTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-task-type-attribute-detail', {
            parent: 'custom-task-type-attribute',
            url: '/custom-task-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-detail.html',
                    controller: 'CustomTaskTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
                    return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-task-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-task-type-attribute-detail.edit', {
            parent: 'custom-task-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-task-type-attribute.new', {
            parent: 'custom-task-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('custom-task-type-attribute');
                });
            }]
        })
        .state('custom-task-type-attribute.edit', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-task-type-attribute.delete', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-delete-dialog.html',
                    controller: 'CustomTaskTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
